/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import DomEventsManager from 'scripts/dom-events-manager';
import _ from 'lodash';
import navigationRenderer from './history-experience-header-navigation.stache';
import BaseMap from 'scripts/models/base/map';
import BaseList from 'scripts/models/base/list';

export const HistoryExperienceHeader = BaseControl.extend({
    init() {
        this._super();
        DomEventsManager.subscribe(this);

        this.initNavigation();
    },

    initNavigation: function() {
        this.navigationModel = new BaseMap({
            width: 0,
            items: new BaseList([]),
            rootPath: this.options.pagePath,
            isAllFit: true,
            isMenuOpened: false,
            uniqueId: this.options.uniqueId,
        });

        this.can.batch.start();
        _.forEach(this.options.navigation, (item) => {
            item.isFit = false;
            item.isActive = this.isActiveHistoryLink(
                item.link,
                this.options.pagePath,
            );
            this.navigationModel.attr('items').push(item);
        });
        this.can.batch.stop();

        this.$element
            .find('.s-history-experience-header-navigation')
            .html(navigationRenderer(this.navigationModel));

        this.$navigationWrapper = this.$element.find(
            '.s-history-experience-header-navigation__container',
        );
        this.$fontOptions = this.$element.find('.js-font-options').last();

        this.navigationModel.bind(
            'width',
            this.checkNavigationItemsCount.bind(this),
        );
        this.getNavigationWrapperWidth();

        this.can.$('body').on('click', (e) => {
            if (
                !this.can
                    .$(e.target)
                    .closest(
                        '.s-history-experience-header-navigation-overflow-menu__button',
                    ).length
            ) {
                this.navigationModel.attr('isMenuOpened', false);
            }
        });
    },

    getNavigationWrapperWidth: function() {
        const socialShareIconWidth = this.element
            .find('.s-history-experience-header-navigation__share-link')
            .width();
        const width =
            this.$navigationWrapper.width() -
            socialShareIconWidth * 2 +
            parseFloat(this.$fontOptions.css('padding-left'));

        this.navigationModel.attr('width', width);
    },

    checkNavigationItemsCount: function(width) {
        const AVERAGE_CHAR_WIDTH_RATIO = 0.6;
        let navigationWrapperWidth = this.navigationModel.attr('width');
        let fontSize = parseFloat(this.$fontOptions.css('font-size'));
        let letterSpacing = parseFloat(this.$fontOptions.css('letter-spacing'));
        let itemPadding = parseFloat(this.$fontOptions.css('padding-left'));
        let charWidth = fontSize * AVERAGE_CHAR_WIDTH_RATIO + letterSpacing;

        let itemsWidth = 0;

        this.navigationModel.attr('isAllFit', true);

        let isAllFit = true;
        this.navigationModel.attr('items').each((item) => {
            this.itemWidth =
                item.attr('label').length * charWidth + 2 * itemPadding + 5;
            if (
                itemsWidth + this.itemWidth <= navigationWrapperWidth &&
                isAllFit
            ) {
                itemsWidth += this.itemWidth;
                item.attr('isFit', true);
            } else {
                isAllFit = false;
                this.navigationModel.attr('isAllFit', false);
                item.attr('isFit', false);
            }
        });
    },

    onWindowResize: function() {
        this.debouncedWindowResize();
    },

    debouncedWindowResize: _.debounce(function() {
        this.getNavigationWrapperWidth();
    }, 100),

    '.s-history-experience-header-navigation-overflow-menu__button click'(
        element,
    ) {
        this.navigationModel.attr(
            'isMenuOpened',
            !this.navigationModel.attr('isMenuOpened'),
        );
    },

    '.js-mobile-search click'(element) {
        element
            .closest('.js-nav-container')
            .find('.js-search')
            .slideDown();
    },

    isActiveHistoryLink(url, pagePath) {
        let urlForCompare = url.replace('.html', '');
        let pagePathForCompare = pagePath.replace('.html', '');

        if (url.split('/').length > 3) {
            urlForCompare = url
                .split('/')
                .slice(0, -1)
                .join('/');
            pagePathForCompare = pagePath
                .split('/')
                .slice(0, -1)
                .join('/');
        }

        let result = urlForCompare === pagePathForCompare;
        if (!result && pagePathForCompare) {
            result = pagePathForCompare.indexOf(urlForCompare) > -1;
        }
        return result;
    },
});
